// extracted by mini-css-extract-plugin
export default {"illustration":"arcana-desc-modal_illustration__5n6O8"};